import { ModuleFE_BaseApi, apiWithQuery } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_Reference, reference_isArticle, reference_isBook, reference_isCPT, reference_isICD, reference_isLoinc, reference_isRxCUI, reference_isATC, reference_isSnomed, reference_isUpToDate } from '@app/hcs-shared';
import { filterInstances } from '@nu-art/ts-common';
import { ModuleFE_Variable } from '../variable/index.js';
import { ApiDef_Snomed } from '@app/hcs-shared/_entity/reference/api-def';
export const dispatch_onReferencesUpdated = new ThunderDispatcherV3('__onReferencesUpdated');
export class ModuleFE_Reference_Class extends ModuleFE_BaseApi {
    _snomed;
    __searchFilterMapper = (item) => {
        return filterInstances([item.data?.id,
            item.data?.bookId,
            item.data?.name,
            item.data?.names?.join(' ')]);
    };
    __searchGroups = (items) => {
        return [];
    };
    constructor() {
        super(DBDef_Reference, dispatch_onReferencesUpdated);
        this.__searchGroups = ModuleFE_Variable.__searchGroupsRefs;
        this._snomed = {
            scrapeBySearchTerm: apiWithQuery(ApiDef_Snomed._v1.scrapeBySearchTerm),
        };
    }
    is = {
        snomed: reference_isSnomed,
        loinc: reference_isLoinc,
        icdCode: reference_isICD,
        article: reference_isArticle,
        book: reference_isBook,
        upToDate: reference_isUpToDate,
        cpt: reference_isCPT,
        rxcui: reference_isRxCUI,
        atc: reference_isATC
    };
}
export const ModuleFE_Reference = new ModuleFE_Reference_Class();
//# sourceMappingURL=ModuleFE_Reference.js.map